import messages from './ReportBox.intl';
import Intl from './../../../../../../common/messages/Intl';
import { getReportURL } from 'utils/link-generator-utils';

function nameof(variable) {
  // Jeśli zmienna jest obiektem, możemy próbować uzyskać nazwę właściwości
  if (typeof variable === 'object')
    return variable['constructor'] && variable['constructor'].name;

  // Jeśli zmienna nie jest obiektem lub nie udało się znaleźć nazwy konstruktora, zwracamy null
  return null;
}

class ReportBoxModel {
  constructor(data) {
    const _data = data || {};
    this.getData = function() {
      return _data;
    };
  }

  get title() {
    return this.getData().title || '';
  }
  get label() {
    return this.getData().label || '';
  }
  get description() {
    return this.getData().description || '';
  }
  get url() {
    return this.getData().url || '';
  }
}

class AbstractModelExtractor {
  constructor() {
    if (this.constructor === AbstractModelExtractor) {
      throw new TypeError(`Cannot instantiate ${nameof(this)} directly.`);
    }
  }

  extract() {
    throw new Error(`Method ${nameof(this.extract)} must be implemented.`);
  }
}

export class IssueOfSharesModelExtractor extends AbstractModelExtractor {
  constructor(issueOfShares) {
    super();

    const _data = issueOfShares || {};
    this.getData = function() {
      return _data;
    };
  }

  extract() {
    const data = this.getData();

    return new ReportBoxModel({
      title: data.title,
      label: Intl.t(messages.issueOfSharesButton),
      description: Intl.t(messages.issueOfShares),
      url: data.url
    });
  }
}

export class AnnualReportModelExtractor extends AbstractModelExtractor {
  constructor(annualReport) {
    super();

    const _data = annualReport;
    this.getData = function() {
      return _data;
    };
  }

  extract() {
    const data = this.getData();
    const {
      reportFile: { url },
      year
    } = data;

    return new ReportBoxModel({
      title: Intl.t(messages.annualSipleReportTitle, { year }),
      label: Intl.t(messages.button),
      description: Intl.t(messages.description),
      url: url
    });
  }
}

export class OtherReportModelExtractor extends AbstractModelExtractor {
  constructor(report) {
    super();
    var _data = report;

    this.getData = function() {
      return _data;
    };
  }

  extract() {
    const data = this.getData();
    const isYearly = data.quarter === 'Roczny';
    const { year, quarter, period } = data;
    const title = isYearly
      ? Intl.t(messages.title, { year })
      : Intl.t(messages.titleQuarter, { year, quarter });

    return new ReportBoxModel({
      title: title,
      label: Intl.t(messages.button),
      description: Intl.t(messages.description),
      url: getReportURL({ year, period })
    });
  }
}

// used to service no values case
export class EmptyReportModelExtractor extends AbstractModelExtractor {
  extract() {
    console.log(`${nameof(this)}, Empty report model.`);
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/views/Home/Sections/Intro/Components/ReportBox/ReportBox.utils.js